export default __webpack_public_path__ + "static/media/ppcp.a67557b7.jpg";